var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgResourcesCenter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "17px",
    viewBox: "0 0 9 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-867.000000, -124.000000)",
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(846.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(17.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Editor-/-attach_file",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16.54 0 16.54 17 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.37125,4.25 L11.37125,12.3958333 C11.37125,13.96125 10.1376417,15.2291667 8.61458333,15.2291667 C7.091525,15.2291667 5.85791667,13.96125 5.85791667,12.3958333 L5.85791667,3.54166667 C5.85791667,2.56416667 6.62978333,1.77083333 7.58083333,1.77083333 C8.53188333,1.77083333 9.30375,2.56416667 9.30375,3.54166667 L9.30375,10.9791667 C9.30375,11.36875 8.993625,11.6875 8.61458333,11.6875 C8.23554167,11.6875 7.92541667,11.36875 7.92541667,10.9791667 L7.92541667,4.25 L6.89166667,4.25 L6.89166667,10.9791667 C6.89166667,11.9566667 7.66353333,12.75 8.61458333,12.75 C9.56563333,12.75 10.3375,11.9566667 10.3375,10.9791667 L10.3375,3.54166667 C10.3375,1.97625 9.10389167,0.708333333 7.58083333,0.708333333 C6.057775,0.708333333 4.82416667,1.97625 4.82416667,3.54166667 L4.82416667,12.3958333 C4.82416667,14.5491667 6.51951667,16.2916667 8.61458333,16.2916667 C10.70965,16.2916667 12.405,14.5491667 12.405,12.3958333 L12.405,4.25 L11.37125,4.25 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResourcesCenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resources-center.a83a059c.svg";
export { ForwardRef as ReactComponent };